import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, mergeProps as _mergeProps, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { ref, computed, watch, useAttrs } from 'vue';
import ExternalPersonTag from './ExternalPersonTag.vue';
import ExternalPersonPicker from './ExternalPersonPicker.vue';
import { useFormDisabled } from 'element-plus';
import { getExternalPersonOptions } from '@/api/taxPlanning';
export default /*@__PURE__*/Object.assign({
  inheritAttrs: false
}, {
  __name: 'index',
  props: {
    modelValue: {
      type: [Number, String],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择外部人员'
    },
    // 已选人员不在启用下拉数据源中时（如已停用）的兜底显示名
    fallbackName: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(__props, {
    emit: __emit
  }) {
    const $props = __props;
    // change 事件抛出选中人员对象（用于表单自动带出持卡人姓名）
    const $emits = __emit;
    const attrs = useAttrs();

    // 已选人员姓名映射：编辑回填时根据ID从下拉数据源反查
    const personMap = ref({});
    const loadPersonInfo = async id => {
      if (!id || personMap.value[id]) return;
      try {
        const list = (await getExternalPersonOptions()) || [];
        list.forEach(person => {
          personMap.value[person.id] = {
            id: person.id,
            name: person.name
          };
        });
      } catch (error) {
        console.error('加载外部人员信息失败:', error);
      }
    };
    watch(() => $props.modelValue, val => {
      if (val) loadPersonInfo(val);
    }, {
      immediate: true
    });
    const selectedPerson = computed(() => {
      if (!$props.modelValue) return null;
      return personMap.value[$props.modelValue] || {
        id: $props.modelValue,
        name: $props.fallbackName || ''
      };
    });
    const formDisabled = useFormDisabled();
    const disabled = computed(() => formDisabled.value || $props.disabled);
    const isEmpty = computed(() => !$props.modelValue);
    const clickable = computed(() => !disabled.value);
    const pickerRef = ref();
    const openPicker = () => {
      if (!clickable.value) return;
      pickerRef.value?.open();
    };
    const onPickerConfirm = persons => {
      const person = persons[0] || null;
      if (person?.id) {
        personMap.value[person.id] = {
          id: person.id,
          name: person.name || ''
        };
      }
      $emits('update:modelValue', person?.id ?? null);
      $emits('change', person);
    };
    const onClose = () => {
      $emits('update:modelValue', null);
      $emits('change', null);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(ExternalPersonPicker, {
        ref_key: "pickerRef",
        ref: pickerRef,
        "model-value": __props.modelValue,
        onConfirm: onPickerConfirm
      }, null, 8, ["model-value"]), _createElementVNode("div", _mergeProps(_unref(attrs), {
        class: ["person-selector", {
          'is-disabled': disabled.value,
          'is-empty': isEmpty.value,
          'is-clickable': clickable.value
        }],
        onClick: openPicker
      }), [selectedPerson.value ? (_openBlock(), _createBlock(ExternalPersonTag, {
        key: 0,
        closable: !disabled.value,
        disabled: disabled.value,
        id: selectedPerson.value.id,
        name: selectedPerson.value.name,
        onClose: onClose
      }, null, 8, ["closable", "disabled", "id", "name"])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("span", {
        class: "person-selector-placeholder"
      }, _toDisplayString(__props.placeholder), 513), [[_vShow, isEmpty.value]])], 16)], 64);
    };
  }
});